var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/environments.ts
var environments = {
  PROD_API_URL: "https://api.graodireto.com.br",
  HOMOLOG_API_URL: "https://api-homolog.graodireto.com.br",
  DEV_API_URL: "http://localhost:3333"
};

// src/index.ts
if (typeof window !== "undefined") {
  class NpsModal extends HTMLElement {
    constructor() {
      super();
      this.isSubmitting = false;
      this.selectedRating = null;
      this.step = "rating";
      this.attachShadow({ mode: "open" });
      if (this.shadowRoot) {
        this.shadowRoot.innerHTML = this.generateHTML();
      }
      this.initializeElements();
      this.setupEventListeners();
    }
    generateHTML() {
      return `
      <style>
      :host {
        --nps-primary-color: #67A22D;
        --nps-secondary-color: #fff;
        --nps-border-radius: 8px;
        --nps-button-padding: 8px 16px;
        --nps-button-font-size: 16px;
        --nps-modal-bg-color: rgba(0, 0, 0, 0.4);
        --nps-modal-content-bg-color: #fefefe;
        --nps-modal-padding: 32px;
        --nps-modal-border-color: #888;
        --nps-modal-border-radius: 12px;
        --nps-justification-border-color: #D0D0D0;
        --nps-justification-font-size: 12.8px;
      }

      .modal {
        position: fixed;
        z-index: 9999999 !important;
        left: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        overflow: auto;
        background-color: var(--nps-modal-bg-color);
        backdrop-filter: blur(8px);
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.3s ease;
      }

      .modal.show {
        opacity: 1;
        visibility: visible;
      }

      .modal-content {
        box-sizing: border-box;
        margin: 15% auto;
        background-color: var(--nps-modal-content-bg-color);
        padding: var(--nps-modal-padding);
        border: 1px solid var(--nps-modal-border-color);
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;
        max-width: 730px;
        height: fit-content;
        border-radius: var(--nps-modal-border-radius);
        position: relative;
        font-size: 20px;
        font-family: inherit;
      }

      #question, #reason {
        font-weight: 600;
        margin: 0;
      }

      #question strong {
        font-weight: 700;
      }

      .rating-buttons {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        gap: 12px;
        margin: 24px 0;
      }

      .rating-button {
        width: 48px;
        height: 36px;
        border-radius: var(--nps-border-radius);
        cursor: pointer;
        font-size: var(--nps-button-font-size);
        font-weight: 600;
        color: var(--nps-secondary-color);
        border: 2px solid;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
      }

      .rating-button[data-value="0"] { background-color: #D32F2F; border-color: #D32F2F; }
      .rating-button[data-value="1"] { background-color: #CF422A; border-color: #CF422A; }
      .rating-button[data-value="2"] { background-color: #D65929; border-color: #D65929; }
      .rating-button[data-value="3"] { background-color: #DC6F28; border-color: #DC6F28; }
      .rating-button[data-value="4"] { background-color: #E38526; border-color: #E38526; }
      .rating-button[data-value="5"] { background-color: #E99B24; border-color: #E99B24; }
      .rating-button[data-value="6"] { background-color: #F0B121; border-color: #F0B121; }
      .rating-button[data-value="7"] { background-color: #FCC836; border-color: #FCC836; }
      .rating-button[data-value="8"] { background-color: #B7C522; border-color: #B7C522; }
      .rating-button[data-value="9"] { background-color: #7AC224; border-color: #7AC224; }
      .rating-button[data-value="10"] { background-color: #2BBE32; border-color: #2BBE32; }

      .off {
        background-color: transparent !important;
      }

     .justification {
        border: 1px solid var(--nps-justification-border-color);
        border-radius: var(--nps-border-radius);
        outline: none;
        padding: 8px;
        margin-bottom: 24px;
        width: 100%;
        max-width: 100%; /* Garante que o textarea n\xE3o ultrapasse o tamanho da div */
        min-height: 98px;
        max-height: 200px;
        font-family: inherit;
        font-size: var(--nps-justification-font-size);
        resize: none;
        box-sizing: border-box;
      }

      .justification::placeholder {
        color: #616161;
      }

      .selected-rating-container {
        margin: 12px 0 28px;
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .selected-rating-label {
        font-size: 14px;
      }

      .buttons {
        display: flex;
        flex-direction: row;
        gap: 8px;
        width: 100%;
        justify-content: flex-end;
      }

      .button {
        box-sizing: border-box;
        border-radius: var(--nps-border-radius);
        padding: 8px 16px;
        cursor: pointer;
        font-family: inherit;
        font-size: 20px;
        font-weight: 600;
        transition: all 0.3s ease;
      }

      .primary-button {
        background-color: var(--nps-primary-color);
        color: var(--nps-secondary-color);
        border: 2px solid transparent;
      }

      .secondary-button {
        background-color: transparent;
        color: var(--nps-primary-color);
        border: 2px solid var(--nps-primary-color);
      }

      .button:hover {
        filter: brightness(1.3);
      }

      .hidden {
        display: none;
      }

      .active {
        display: block;
        width: 100%;
      }

      @media (max-width: 800px) {
        .modal {
          width: 100%;
          height: 100%;
        }

        .modal-content {
          width: 80%;
          max-width: 520px;
          margin: 40% auto;
          padding: 24px;
        }
      }

      @media (max-width: 500px) {
        .modal-content {
          width: 100%;
          max-width: 100%;
          padding: 24px;
          border-radius: 0;
          height: 100%;
          margin: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        #question, #reason {
          font-size: 16px;
        }

        .rating-buttons {
          gap: 6px;
          margin: 24px 0 32px;
        }

        .selected-rating-container {
          margin: 12px 0 16px;
        }

        .buttons {
          flex-direction: column-reverse;
          gap: 8px;
        }

        .button {
          width: 100%;
        }

        .primary-button {
          font-size: 14px;
          height: 40px;
        }

        .secondary-button {
          font-size: 12.8px;
        }
    </style>
    <div class="modal">
      <div class="modal-content">
        <div id="rating-step" class="hidden active">
          <p id="question">Em uma escala de 0 a 10, o quanto voc\xEA indicaria a <strong>Gr\xE3o Direto</strong> para algum amigo?</p>
          <div class="rating-buttons">
            ${[...Array(11).keys()].map(
        (i) => `<button class="rating-button" data-value="${i}">${i}</button>`
      ).join("")}
          </div>
          <div class="buttons">
            <button class="button secondary-button" id="laterButton">Responder depois</button>
            <button class="button primary-button" id="submitButton">Enviar</button>
          </div>
        </div>

        <div id="justification-step" class="hidden">
          <p id="reason">Gostaria de nos contar o motivo da sua nota?</p>
          <div class="selected-rating-container">
            <span id="selectedRatingLabel" class="selected-rating-label">Nota enviada:</span>
            <span id="selected-rating" class="rating-button"></span>
          </div>
          <textarea class="justification" id="justification" name="justification" placeholder="Digite seu coment\xE1rio aqui."></textarea>
          <div class="buttons">
            <button class="button primary-button" id="confirmButton">Concluir</button>
          </div>
        </div>
      </div>
    </div>
    `;
    }
    initializeElements() {
      if (this.shadowRoot) {
        this.modal = this.shadowRoot.querySelector(".modal");
        this.submitButton = this.shadowRoot.querySelector(
          "#submitButton"
        );
        this.laterButton = this.shadowRoot.querySelector(
          "#laterButton"
        );
        this.confirmButton = this.shadowRoot.querySelector(
          "#confirmButton"
        );
        this.ratingButtons = this.shadowRoot.querySelectorAll(".rating-button");
        this.justificationInput = this.shadowRoot.querySelector(
          "#justification"
        );
        this.ratingStep = this.shadowRoot.querySelector("#rating-step");
        this.justificationStep = this.shadowRoot.querySelector(
          "#justification-step"
        );
        this.selectedRatingDisplay = this.shadowRoot.querySelector("#selected-rating");
      }
    }
    setupEventListeners() {
      this.laterButton.addEventListener(
        "click",
        () => this.handleSubmitAnswer({ isAnswerLater: true })
      );
      this.submitButton.addEventListener(
        "click",
        () => this.goToJustification()
      );
      this.confirmButton.addEventListener(
        "click",
        () => this.handleSubmitAnswer({ isAnswerLater: false })
      );
      this.ratingButtons.forEach(
        (button) => button.addEventListener("click", this.handleRatingSelection.bind(this))
      );
    }
    handleRatingSelection(event) {
      const target = event.target;
      this.selectedRating = target.getAttribute("data-value");
      this.updateRatingAppearance(target);
    }
    updateRatingAppearance(selectedButton) {
      this.ratingButtons.forEach((button) => {
        const isOff = button !== selectedButton;
        button.classList.toggle("off", isOff);
        if (isOff) {
          const computedStyle = getComputedStyle(button);
          const borderColor = computedStyle.borderColor;
          button.style.color = borderColor;
        } else {
          button.style.color = "var(--nps-secondary-color)";
        }
      });
    }
    goToJustification() {
      if (this.selectedRating === null) {
        alert("Por favor, selecione uma nota.");
        return;
      }
      this.selectedRatingDisplay.textContent = this.selectedRating;
      this.handleSelectedRatingDisplay();
      this.switchToJustificationStep();
    }
    handleSelectedRatingDisplay() {
      const ratingValue = Number(this.selectedRating);
      const selectedButton = this.shadowRoot.querySelector(
        `.rating-button[data-value="${ratingValue}"]`
      );
      if (selectedButton) {
        this.selectedRatingDisplay.classList.remove("off");
        const computedStyle = getComputedStyle(selectedButton);
        this.selectedRatingDisplay.style.backgroundColor = computedStyle.backgroundColor;
        this.selectedRatingDisplay.style.color = "var(--nps-secondary-color)";
      }
    }
    switchToJustificationStep() {
      this.ratingStep.classList.remove("active");
      this.justificationStep.classList.add("active");
      this.step = "justification";
    }
    getApiParams(env) {
      switch (env) {
        case "prod":
          return {
            apiUrl: environments.PROD_API_URL
          };
        case "homolog":
          return {
            apiUrl: environments.HOMOLOG_API_URL
          };
        case "dev":
          return {
            apiUrl: environments.DEV_API_URL
          };
        default:
          return {
            apiUrl: environments.HOMOLOG_API_URL
          };
      }
    }
    handleSubmitAnswer(props) {
      return __async(this, null, function* () {
        if (this.apiUrl && !this.isSubmitting) {
          this.isSubmitting = true;
          const justification = this.justificationInput.value;
          const reqBody = {
            uid: this.uid,
            sourceId: this.sourceId,
            score: props.isAnswerLater ? -1 : Number(this.selectedRating),
            comment: justification,
            hash: this.hash
          };
          try {
            yield fetch(`${this.apiUrl}/api/nps-answer`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `JWT ${this.tempToken}`
              },
              body: JSON.stringify(reqBody)
            });
            this.close();
          } catch (error) {
            console.error(error);
            this.close();
          } finally {
            this.isSubmitting = false;
          }
        }
      });
    }
    open(_0) {
      return __async(this, arguments, function* ({
        uid,
        sourceId,
        hash,
        tempToken,
        lang = "pt-BR",
        env = "homolog"
      }) {
        this.modal.classList.add("show");
        const { apiUrl } = this.getApiParams(env);
        if (apiUrl && hash && tempToken) {
          Object.assign(this, { hash, apiUrl, sourceId, uid, tempToken });
          this.resetStepToRating();
          this.resetSelectedRating();
          this.resetJustificationInput();
          this.resetRatingButtons();
          this.updateTexts(lang);
        }
      });
    }
    resetStepToRating() {
      this.step = "rating";
      this.ratingStep.classList.add("active");
      this.justificationStep.classList.remove("active");
    }
    resetSelectedRating() {
      this.selectedRating = null;
    }
    resetJustificationInput() {
      this.justificationInput.value = "";
    }
    resetRatingButtons() {
      this.ratingButtons.forEach((button) => {
        button.classList.remove("off");
        button.style.color = "var(--nps-secondary-color)";
      });
    }
    close() {
      this.modal.classList.remove("show");
    }
    updateTexts(textContentOrLang) {
      const textElements = {
        question: this.shadowRoot.querySelector("#question"),
        reason: this.shadowRoot.querySelector("#reason"),
        submitButton: this.shadowRoot.querySelector("#submitButton"),
        laterButton: this.shadowRoot.querySelector("#laterButton"),
        selectedRatingLabel: this.shadowRoot.querySelector(
          "#selectedRatingLabel"
        ),
        confirmButton: this.shadowRoot.querySelector("#confirmButton")
      };
      const justificationInput = this.shadowRoot.querySelector(
        "#justification"
      );
      const texts = {
        en: {
          question: "On a scale of 0 to 10, how likely are you to recommend <strong>Gr\xE3o Direto</strong> to a friend?",
          reason: "Would you like to tell us why you gave this score?",
          submitButton: "Send",
          laterButton: "Answer later",
          selectedRatingLabel: "Selected rating:",
          justificationPlaceholder: "Type your comment here.",
          confirmButton: "Complete"
        },
        "pt-BR": {
          question: "Em uma escala de 0 a 10, o quanto voc\xEA indicaria a <strong>Gr\xE3o Direto</strong> para algum amigo?",
          reason: "Gostaria de nos contar o motivo da sua nota?",
          submitButton: "Enviar",
          laterButton: "Responder depois",
          selectedRatingLabel: "Nota enviada:",
          justificationPlaceholder: "Digite seu coment\xE1rio aqui.",
          confirmButton: "Concluir"
        },
        es: {
          question: "En una escala del 0 al 10, \xBFqu\xE9 probabilidad hay de que recomiende <strong>Gr\xE3o Direto</strong> a un amigo?",
          reason: "\xBFLe gustar\xEDa contarnos el motivo de su calificaci\xF3n?",
          submitButton: "Enviar",
          laterButton: "Responder despu\xE9s",
          selectedRatingLabel: "Calificaci\xF3n seleccionada:",
          justificationPlaceholder: "Escribe tu comentario aqu\xED.",
          confirmButton: "Concluir"
        }
      };
      const textContent = typeof textContentOrLang === "string" ? texts[textContentOrLang] : textContentOrLang;
      Object.keys(textContent).forEach((key) => {
        if (key === "reason") {
          textElements[key].textContent = textContent[key];
        } else if (key === "question") {
          textElements[key].innerHTML = textContent[key];
        } else if (key === "justificationPlaceholder") {
          justificationInput.placeholder = textContent[key];
        } else {
          textElements[key].textContent = textContent[key];
        }
      });
    }
  }
  customElements.define("nps-modal", NpsModal);
}
//# sourceMappingURL=index.mjs.map